<template>
    <div class="filterbarWrapper">

        <div v-bind:style="{ display: displayMode }" class="filterList">

            <div v-for="fdef in variableFilterDefs" :key="fdef.extname">
                <VariableFilter :filter-def="fdef"/>
            </div>

        </div>

    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import VariableFilter from "./VariableFilter";

    export default {
        name: 'FilterSidebar',

        components: {VariableFilter},

        props: {
            expanded: Boolean
        },

        computed: {
            ...mapGetters(['pages', 'completePath', 'variableFilterDefs']),

            displayMode() {
                return this.expanded ? 'block' : 'none'
            }

        },

        methods: {

        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .filterbarWrapper {
        background: #757575;
        color: white;
        padding-left: 1em;
        padding-right: 1em;
    }
</style>
